<template>
<div class="-mx-4 mt-4 bg-red-50 p-4 sm:mx-0 sm:rounded-md">
  <div class="flex">
    <div class="hidden flex-shrink-0 sm:block">
      <XCircleIcon class="w-6 h-6 text-red-400" />
    </div>
    <div class="sm:ml-3">
      <div class="flex items-center space-x-2 sm:space-x-0">
        <XCircleIcon class="w-6 h-6 self-start text-red-400 sm:hidden" />
        <h3 class="text-s font-medium text-red-800">You need to renew your DBS Check!</h3>
      </div>
      <div class="mt-2 prose prose-sm">
        <p>
          A condition of our DBS Check requires the certificate to be issued within the last three years.
        </p>
        <table class="my-auto w-auto text-sm">
          <tr>
            <th colspan="2">Most recent certificate</th>
          </tr>
          <tr>
            <td class="pr-3">Certificate Number</td>
            <td><strong>{{ certificateNumber }}</strong></td>
          </tr>
          <tr>
            <td>Issued</td>
            <td><strong>{{ dayjs(certificateIssuedWhen).format('LL') }}</strong></td>
          </tr>
          <tr>
            <td>Overdue by</td>
            <td><strong>{{ dayjs(certificateValidUntil).fromNow(true) }}</strong></td>
          </tr>
        </table>
        <p>
          Until a new DBS Check has been completed, the DBS Shield (<CheckShieldIcon class="w-6 h-6 text-blue-500 inline" />) will no longer appear on your profile and search results.
        </p>

        <h3>
          Next step…
        </h3>
        <p>
          Our DBS Check is provided <strong>free of charge</strong>. If required, you can also purchase a new DBS certificate through us.
        </p>
        <div class="flex items-center space-x-3">
          <TailwindButton
            @click="$emit('showSubmitDbsForm')"
            class="flex-1 w-40 h-16 sm:flex-initial"
          >
            I already have a DBS certificate
          </TailwindButton>
          <TailwindButton
            @click="$emit('showRequestDbsForm')"
            class="flex-1 w-40 h-16 sm:flex-initial"
          >
            I need a new DBS certificate
          </TailwindButton>
        </div>
        <!-- <div class="flex flex-row items-center space-x-3">
          <router-link
            :to="{ name: 'PayTutor', params: { id: $store.getters.user.PublicId, stub: $store.getters.user.Name.replace(/ /g, '-').toLowerCase() } }"
            class="leading-tight text-base underline"
          >{{ $store.state.user.PublicId }}-{{ $store.state.user.Name.replace(/ /g, '-').toLowerCase() }}/pay</router-link>
          <button v-if="navigatorAvailable" type="button" @click="onCopy" class="flex items-center space-x-1 text-sm text-gray-500 hover:text-gray-600">
            <DuplicateIcon class="w-5 h-5" />
            <span v-show="showCopiedText">Copied!</span>
          </button>
          <button v-if="navigatorAvailable" type="button" @click="onShare" class="flex items-center space-x-1 text-sm text-gray-500 hover:text-gray-600">
            <ShareIcon class="w-5 h-5" />
          </button>
        </div> -->

        <!-- <button type="button" @click="$emit('showSubmitDbsForm')">Submit</button>
        <button type="button" @click="$emit('showRequestDbsForm')">Apply</button> -->
        <!-- <p class="text-xs">To manage your Stripe account, <a href="https://dashboard.stripe.com/login" target="_blank">sign in</a> to your account at stripe.com.</p> -->
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { XCircleIcon } from '@vue-hero-icons/solid'
import CheckShieldIcon from '../../components/CheckShieldIcon.vue'
import dayjs from 'dayjs'
import localizedFormat from 'dayjs/plugin/localizedFormat'
import relativeTime from 'dayjs/plugin/relativeTime'
import TailwindButton from '../TailwindButton.vue'

dayjs.extend(localizedFormat)
dayjs.extend(relativeTime)

export default {
  components: {
    XCircleIcon,
    CheckShieldIcon,
    TailwindButton,
  },
  props: {
    certificateNumber: String,
    certificateIssuedWhen: Date,
    certificateValidUntil: Date,
  },
  data() {
    return {
      dayjs
    }
  }
}
</script>

<style>

</style>